/**
 * FRUGAL QUOTES - Dashboard Curtain (English)
 * 50+ famous quotes about frugality, saving and simple living
 */

export const FRUGAL_QUOTES_EN = [
  // Frugality and Simplicity
  { text: "There is no dignity quite so impressive, and no independence quite so important, as living within your means.", author: "Calvin Coolidge" },
  { text: "I make myself rich by keeping my needs low.", author: "Henry David Thoreau" },
  { text: "Simplicity is the ultimate sophistication.", author: "Leonardo da Vinci" },
  { text: "Wealth consists not in having great possessions, but in having few wants.", author: "Epictetus" },
  { text: "Live simply so that others may simply live.", author: "Mahatma Gandhi" },
  
  // Saving and Finance
  { text: "Do not save what is left after spending, but spend what is left after saving.", author: "Warren Buffett" },
  { text: "A penny saved is a penny earned.", author: "Benjamin Franklin" },
  { text: "The best investment you can make is in yourself.", author: "Warren Buffett" },
  { text: "Money is a good servant but a bad master.", author: "Francis Bacon" },
  { text: "Save when you can and not when you have to.", author: "John D. Rockefeller" },
  
  // Financial Wisdom
  { text: "Be industrious and frugal, and you will be rich.", author: "Benjamin Franklin" },
  { text: "He who will not economize will have to agonize.", author: "Confucius" },
  { text: "Without frugality none can be rich, and with it very few would be poor.", author: "Benjamin Franklin" },
  { text: "The penny saved is more honest than the penny earned.", author: "Martin Luther" },
  { text: "Take care of the pennies and the pounds will take care of themselves.", author: "Proverb" },
  
  // Conscious Living
  { text: "He who has little is not poor, but he who wants more.", author: "Seneca" },
  { text: "I have learned to seek my happiness in limiting my desires instead of trying to satisfy them.", author: "John Stuart Mill" },
  { text: "Less is more.", author: "Ludwig Mies van der Rohe" },
  { text: "It is health that is real wealth and not pieces of gold and silver.", author: "Mahatma Gandhi" },
  { text: "He who buys what he does not need steals from himself.", author: "Swedish Proverb" },
  
  // Financial Freedom
  { text: "Financial independence is the ability to live from the income of your own personal resources.", author: "Jim Rohn" },
  { text: "Debt is the slavery of the free.", author: "Publilius Syrus" },
  { text: "Rule No. 1: Never lose money. Rule No. 2: Never forget Rule No. 1.", author: "Warren Buffett" },
  { text: "Risk comes from not knowing what you're doing.", author: "Warren Buffett" },
  { text: "In our view, it is madness to risk losing what you need in pursuing what you simply desire.", author: "Warren Buffett" },
  
  // Patience and Persistence
  { text: "Compound interest is the eighth wonder of the world.", author: "Albert Einstein" },
  { text: "Someone's sitting in the shade today because someone planted a tree a long time ago.", author: "Warren Buffett" },
  { text: "Our favorite holding period is forever.", author: "Warren Buffett" },
  { text: "Little by little, one travels far.", author: "J.R.R. Tolkien" },
  { text: "Patience is a virtue, especially in financial matters.", author: "ZenSaver" },
  
  // Financial Mindfulness
  { text: "Before you buy, ask yourself: Do I need it or do I want it?", author: "ZenSaver" },
  { text: "Beware of little expenses. A small leak will sink a great ship.", author: "Benjamin Franklin" },
  { text: "A cynic knows the price of everything and the value of nothing.", author: "Oscar Wilde" },
  { text: "Gratitude turns what we have into enough.", author: "Melody Beattie" },
  { text: "Content makes poor men rich; discontent makes rich men poor.", author: "Benjamin Franklin" },
  
  // Planning
  { text: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupery" },
  { text: "The best time to plant a tree was 20 years ago. The second best time is now.", author: "Chinese Proverb" },
  { text: "Failing to plan is planning to fail.", author: "Alan Lakein" },
  { text: "The future belongs to those who prepare for it today.", author: "Malcolm X" },
  { text: "Plan your spending or your spending will plan your life.", author: "ZenSaver" },
  
  // Balance
  { text: "Balance is not something you find, it's something you create.", author: "Jana Kingsford" },
  { text: "Everything in moderation, including moderation.", author: "Oscar Wilde" },
  { text: "Virtue lies in the middle.", author: "Aristotle" },
  { text: "Spend on what you love, save on what you don't.", author: "ZenSaver" },
  { text: "Be gentle and you can be bold; be frugal and you can be liberal.", author: "Lao Tzu" },
  
  // Mindset
  { text: "It's not your salary that makes you rich, it's your spending habits.", author: "Charles A. Jaffe" },
  { text: "It's not how much money you make, but how much you keep.", author: "Robert Kiyosaki" },
  { text: "The mind is everything. What you think you become.", author: "Buddha" },
  { text: "Your attitude, not your aptitude, will determine your altitude.", author: "Zig Ziglar" },
  { text: "Be Fearful When Others Are Greedy and Greedy When Others Are Fearful.", author: "Warren Buffett" },
  
  // Zen and Tranquility
  { text: "Inner peace begins when you stop worrying about material things.", author: "ZenSaver" },
  { text: "The zen of finance is spending consciously.", author: "ZenSaver" },
  { text: "When you control your money, your money doesn't control you.", author: "ZenSaver" },
  { text: "Financial serenity is the true luxury.", author: "ZenSaver" },
  { text: "Your daily ZEN is your daily peace.", author: "ZenSaver" }
];

// Function to get a random quote
export const getRandomQuote = () => {
  const index = Math.floor(Math.random() * FRUGAL_QUOTES_EN.length);
  return FRUGAL_QUOTES_EN[index];
};

// Function to get multiple unique quotes
export const getRandomQuotes = (count = 5) => {
  const shuffled = [...FRUGAL_QUOTES_EN].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};

export default FRUGAL_QUOTES_EN;
